import SearchNoResults from "src/components/SearchNoResults";
import { enumNever } from "src/shared/helpers/generalHelpers";
import SearchCommunities from "../components/SearchCommunities";
import SearchEmptyNoSearch from "../components/SearchEmptyNoSearch";
import SearchGathering from "../components/SearchGathering";
import SearchHeader from "../components/SearchHeader";
import SearchLoading from "../components/SearchLoading";
import { SearchContentRow } from "../types";

const renderSearchRow = ({ item }: { item: SearchContentRow }) => {
	const { variant } = item;
	switch (variant) {
		case "EmptyNoResults":
			return <SearchNoResults />;
		case "EmptyNoSearch":
			return <SearchEmptyNoSearch />;
		case "Loading":
			return <SearchLoading />;
		case "Header":
			return <SearchHeader text={item.text} />;
		case "Communities":
			return <SearchCommunities communities={item.communities} />;
		case "Gathering":
			return <SearchGathering gathering={item.gathering} />;
		default:
			return enumNever(variant);
	}
};
export default renderSearchRow;
